'use client';
import { useTranslations } from 'next-intl';
import { usePathname } from 'next/navigation';
import { useDrawer, SubheaderMyEquipment } from 'components/pcc-components';
import { returnFocusToNavItem } from '../../utils/common-utils';

type MyEquipmentClientProps = {
  href: string | null;
  isLoggedIn: boolean;
  isMobile?: boolean;
  myEquipmentSeoLink: string;
};
export const MyEquipmentClient = ({
  href,
  isLoggedIn,
  isMobile = false,
  myEquipmentSeoLink
}: MyEquipmentClientProps) => {
  const t = useTranslations();
  const currentPath = usePathname();
  const text = t('SIS_EQUIP_LIST');
  const myEquipmentNavItemId = 'myEquipmentNavItem';
  const { initiatorProps } = useDrawer({
    onClose: () => returnFocusToNavItem(`#${myEquipmentNavItemId}`)
  });
  const NavItemProps = {
    href,
    ...(isLoggedIn ? {} : initiatorProps)
  };
  return (
    <SubheaderMyEquipment
      label={text}
      id={myEquipmentNavItemId}
      isCurrent={currentPath === myEquipmentSeoLink}
      navItemProps={NavItemProps}
      displayMobileNavLink={isMobile}
    />
  );
};
